export default __webpack_public_path__ + "static/media/glitch13.6dc11690.png";